/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_numbering = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number each repetition`)
};

const es_tr_numbering = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numera cada repetición`)
};

const de_tr_numbering = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Wiederholung nummerieren`)
};

const nl_tr_numbering = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nummeren bij elke herhaling`)
};

const fr_tr_numbering = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéroter chaque répétition`)
};

const it_tr_numbering = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numera ogni ripetizione`)
};

const pt_br2_tr_numbering = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numerar cada repetição`)
};

const pt_tr_numbering = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numerar cada repetição`)
};

const ja_tr_numbering = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各繰り返しに番号を付ける`)
};

const zh_tr_numbering = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为每次重复编号`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_numbering = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_numbering(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_numbering", locale)
	if (locale === "en") return en_tr_numbering(inputs)
	if (locale === "es") return es_tr_numbering(inputs)
	if (locale === "de") return de_tr_numbering(inputs)
	if (locale === "nl") return nl_tr_numbering(inputs)
	if (locale === "fr") return fr_tr_numbering(inputs)
	if (locale === "it") return it_tr_numbering(inputs)
	if (locale === "pt-BR") return pt_br2_tr_numbering(inputs)
	if (locale === "pt") return pt_tr_numbering(inputs)
	if (locale === "ja") return ja_tr_numbering(inputs)
	return zh_tr_numbering(inputs)
};